'use client'

import { RawHtmlSectionFragmentFragment } from '../../../../../__generated__/graphql/catalog/graphql'
import { PageSection, PageSectionContent } from '../../PageSection.client'
import { ContentfulRawHtml } from '../components/ContentfulRawHtml'

export type ContentfulPageRawHtmlSectionProps = {
  data: RawHtmlSectionFragmentFragment
}

export const ContentfulPageRawHtmlSection = ({ data }: ContentfulPageRawHtmlSectionProps) => {
  return (
    <PageSection>
      <PageSectionContent gutterSize='none'>
        <ContentfulRawHtml {...data} />
      </PageSectionContent>
    </PageSection>
  )
}
